import { IAuthenticationService } from '@/components/login/_domain/auth-service-interface';
import { LoginRequest } from '@/components/login/_domain/requests';
import { LoginResponse } from '@/components/login/_domain/responses';
import { injectable, inject } from 'inversify';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { UserModel } from '@/components/login/_domain';
import { IHttpService, IHttpRequest } from '@/app-modules/http';
import { IConfigurationService } from '@/app-modules/config/config-service-interface';
import { ITogglesService } from '@/app-modules/config';
@injectable()
class AuthenticationService implements IAuthenticationService {
  constructor(@inject(SERVICE_IDENTIFIERS.IHttpService) private readonly httpService: IHttpService,
  @inject(SERVICE_IDENTIFIERS.IConfigurationService) private readonly configurationService: IConfigurationService,
  @inject(SERVICE_IDENTIFIERS.ITogglesService) private readonly toggleService: ITogglesService) {
  }

  public async login(request: LoginRequest): Promise<LoginResponse> {
    const response = new LoginResponse();
    try {
      const useNewEndpoint = this.configurationService.currentEnvironmentTenantIsInternational()
                              && await this.toggleService.isLive('CIC-370_UseNETInternationalLoginEndpoint');
      const httpRequest = this.getHttpRequestForLoginRequest(request);

      if (useNewEndpoint){
        httpRequest.Url = '/login';
      }

      const result = await this.httpService.post(httpRequest, useNewEndpoint);
      if (useNewEndpoint && result.status === 200) {
        response.result = new UserModel(result.data.UserId);
        response.result.CrossCheck = result.data.CrossCheck;
        response.result.Jwt = result.data.Jwt;
        response.result.ADRoles = result.data.ADRoles;
        response.result.Username = result.data.Username;
        response.success = true;
      }
      else if (result.status === 200 && result.data.Status === 200) {
        response.result = new UserModel(result.data.Data.UserId);
        response.result.CrossCheck = result.data.Data.CrossCheck;
        response.result.Jwt = result.data.Data.Jwt;
        response.result.ADRoles = result.data.Data.ADRoles;
        response.result.Username = result.data.Data.Username;
        response.success = true;
      }
      else {
        response.success = false;
      }
    } catch (ex) {
      // TODO: log exception
    }

    return response;
  }

  private getHttpRequestForLoginRequest(request: LoginRequest): IHttpRequest {
    const httpRequest: IHttpRequest = {
      Url: '/user/login',
      Payload: request.payload
    };
    if (request.isActiveDirectoryLoginRequest()) {
      httpRequest.Headers = {
        authorization: 'active-directory'
      };
    }
    return httpRequest;
  }
}

export { AuthenticationService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/login/_domain/auth-service.ts